var map = {
	"./site-logo-desktop-alt.svg": 27081,
	"./site-logo-desktop-footer.svg": 58209,
	"./site-logo-drawer-mobile.svg": 39713,
	"./site-logo-drawer.svg": 49218,
	"./site-logo-tv.svg": 31031,
	"./site-logo-wrapper-mobile-scrolled.svg": 47526,
	"./site-logo-wrapper-mobile.svg": 52649,
	"./site-logo-wrapper-scrolled.svg": 35507,
	"./site-logo-wrapper.svg": 95530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96976;